import { useT } from "../../i18n/hooks.ts";

/**
 * Preview of raw values from a just-uploaded or already-loaded GeoJSON: see
 * at a glance whether a column is a real id (all distinct values) or a
 * category/type with few repeated values — that would already warn why the
 * "N of M matched" count might not be reliable (several geometries
 * "matching" the SAME entity by coincidence). Shared by GisLayerPanel.tsx
 * and LinkGisPanel.tsx.
 */
export function FieldsPreviewTable({
  geojson,
  fields,
  chosenField,
}: {
  geojson: GeoJSON.FeatureCollection;
  fields: string[];
  chosenField: string;
}) {
  const t = useT();
  return (
    <>
      <div className="table-scroll fields-preview-table">
        <table>
          <thead>
            <tr>
              {fields.map((c) => (
                <th key={c} className={c === chosenField ? "chosen-column" : undefined}>
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {geojson.features.slice(0, 8).map((f, i) => (
              <tr key={i}>
                {fields.map((c) => (
                  <td key={c} className={c === chosenField ? "chosen-column" : undefined}>
                    {String(f.properties?.[c] ?? "")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {geojson.features.length > 8 && (
        <p className="table-note">
          {t("fieldsPreviewTable.showingFirst", { n: geojson.features.length })}
        </p>
      )}
    </>
  );
}
